













import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Getter, Mutation } from 'vuex-class';
@Component
export default class DefaultHead extends Vue {
    @Getter('webSiteUrl', { namespace: 'configuration' }) webSiteUrl: string;
    @Getter('ssoBase', { namespace: 'configuration' }) ssoUrl: string;
    @Getter('labUrl', { namespace: 'configuration' }) labUrl: string;
    @Getter('forumsUrl', { namespace: 'configuration' }) forumsUrl: string;
    @Getter('workUrl', { namespace: 'configuration' }) workUrl: string;
    @Getter('language', { namespace: 'language' }) lang: string;
    @Mutation('setLanguage', { namespace: 'language' }) setLanguage!: Function;

    @Mutation('setUser', { namespace: 'user' }) setUser!: Function;
    @Getter('getUser', { namespace: 'user' }) user: any;

    get navConfig() {
        return {
            home: `${this.webSiteUrl}/`,
            tranning: `${this.labUrl}/`,
            competitions: `${this.webSiteUrl}/competitions`,
            discussion: `${this.forumsUrl}/`,
            datasets: `${this.webSiteUrl}/datasets`,
            holdCompetition: `${this.webSiteUrl}/cooperation`,
            information: `${this.webSiteUrl}/information`,
            login: `${this.ssoUrl}/login2`,
            register: `${this.ssoUrl}/register2`,
            work: `${this.workUrl}`,
        };
    }

    get theme() {
        const arr = [];
        arr.push('navbar-default');
        return arr;
    }

    private async switchLang() {
        const lang = this.$i18n.locale === 'zh-CN' ? 'en-US' : 'zh-CN';
        await this.$axios('setLang', { lang });
        this.$i18n.locale = lang;
        this.setLanguage(lang);
    }

    private async handleUserOperate(cmd) {
        if (cmd === 'logout') {
            const loading = this.$loading({
                text: '请稍等',
            });
            //退出登录
            await this.$axios('userLogout', {});
            this.setUser({});
            loading.close();
            window.location.reload();
        }

        if (cmd === 'profile') {
            // this.$router.push("/users/" + this.$store.state.user.id + "/practice");
            window.location.href = `${this.webSiteUrl}/users/${this.user.id}`;
        }

        if (cmd === 'profile-new') {
            // this.$router.push("/users/" + this.$store.state.user.id + "/practice");
            this.$router.push(`/users/${this.$store.state.user.id}`);
        }

        if (cmd === 'setting') {
            window.location.href = `${this.webSiteUrl}/users/settings`;
        }
    }

    mounted(): void {
        this.$i18n.locale = this.lang;
    }
}
